import { useFetchAccount } from '../../../features/account';
import { IPrivateRouteProps } from './types';

export const PrivateRoute = ({ children }: IPrivateRouteProps) => {
  useFetchAccount();

  return children;
};
